module.exports = __webpack_public_path__ + "static/img/logo_black.dfc561f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_black.png
// module id = q3zs
// module chunks = 16